import React from "react";

export default ({ input, id, label,star, type, disabled, meta: { touched, error, warning } }) => {
  return (
    <div className="form-group row">
      <label className="col-md-12 col-lg-3 col-form-label">{label}{star==='*'? <span className='text-danger'>{star}</span>:''}</label>
      <div className="col-md-12 col-lg-9">
        <div className="gj-datepicker-md.small gj-datepicker-bootstrap gj-unselectable input-group">
          <input {...input} id={id} type={type} className="form-control form-control-sm" disabled={disabled} />
        </div>
        <div className="mt-2 text-danger">
          {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
      </div>
    </div>
  )
}
